import React, { PureComponent } from "react";
import styled from "styled-components";
import { Spin } from "antd";
// tslint:disable-next-line:variable-name
const LoadingBody = styled.div`
  height: 100%;
  width: 100%;
  background-color: #020205;
  position: relative;
  .load-icon{
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
/**
 * 加载状态
 * @author 马俊峰
 * @date 2020-07-21
 * @export
 * @class Loading
 * @extends {PureComponent}
 */
export class Loading extends PureComponent {
  render() {
    return(
      <LoadingBody>
        <div className="load-icon">
          <Spin size="large" tip="Loading..." />
        </div>
      </LoadingBody>
    );
  }
}
